import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom';
import NotFound from './components/ui/NotFound.tsx';
import PermissionDenied from './components/ui/PermissionDenied.tsx';
import AppLayout from './components/AppLayout.tsx';
import UnconfirmedBillingPage from './pages/UnconfirmedBillingPage.tsx';
import ConfirmedBillingPage from './pages/ConfirmedBillingPage.tsx';
import HistoryBillingPage from './pages/HistoryBillingPage.tsx';
import RemittanceInstructionListPage from './pages/RemittanceInstructionListPage.tsx';
import RemittanceInstructionPage from './pages/RemittanceInstructionPage.tsx';
import MainPage from './pages/MainPage.tsx';
import RemitSettingListPage from './pages/RemitSettingListPage.tsx';
import RemitSettingStatusesPage from './pages/RemitSettingStatusesPage.tsx';
import BillingSettingsListPage from './pages/BillingSettingsListPage.tsx';
import BillingSettingsPage from './pages/BillingSettingsPage.tsx';
import PartnerListPage from './pages/PartnerListPage.tsx';
import PartnerDetailPage from './pages/PartnerDetailPage.tsx';
import ChainStoreContractNewPage from './pages/ChainStoreContractNewPage.tsx';
import ChainStoreContractEditPage from './pages/ChainStoreContractEditPage.tsx';
import ChainStoreContractInspectPage from './pages/ChainStoreContractInspectPage.tsx';
import RefuelingContractNewPage from './pages/RefuelingContractNewPage.tsx';
import RefuelingContractEditPage from './pages/RefuelingContractEditPage.tsx';
import RefuelingContractInspectPage from './pages/RefuelingContractInspectPage.tsx';
import ParkingContractNewPage from './pages/ParkingContractNewPage.tsx';
import ParkingContractEditPage from './pages/ParkingContractEditPage.tsx';
import ParkingContractInspectPage from './pages/ParkingContractInspectPage.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import BrandListPage from './pages/BrandListPage.tsx';
import MapSearchPage from './pages/MapSearchPage.tsx';
import PlaceInformationPage from './pages/PlaceInformationPage.tsx';
import PendingTickets from './components/ui/tickets/pages/PendingTickets.tsx';
import HistoryTickets from './components/ui/tickets/pages/HistoryTickets.tsx';
import Enrollments from './components/ui/tickets/pages/Enrollments.tsx';
import ParkingRateCreatePage from './pages/ParkingRateCreatePage.tsx';
import ParkingRateEditPage from './pages/ParkingRateEditPage.tsx';
import PaymentMethodListPage from './pages/PaymentMethodListPage.tsx';
import TagListPage from './pages/TagListPage.tsx';
import MessageListPage from './pages/MessageListPage';
import Message from './pages/Message.tsx';
import MessageCreatePage from './pages/MessageCreatePage';
import MessageEditPage from './pages/MessageEditPage';
import MessageInfoPage from './pages/MessageInfoPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route path="forbidden" element={<PermissionDenied />} />
            <Route index element={<MainPage />} />
            <Route path="site-providers/*" element={<Outlet />}>
              <Route index element={<RemitSettingStatusesPage />} />
              <Route
                path=":siteProviderId/remit-settings"
                element={<RemitSettingListPage />}
              />
            </Route>
            <Route path="remittance-instructions/*" element={<Outlet />}>
              <Route index element={<RemittanceInstructionListPage />} />
              <Route path=":id" element={<RemittanceInstructionPage />} />
            </Route>

            <Route path="billing/*" element={<Outlet />}>
              <Route index element={<Navigate to="unconfirmed" replace />} />
              <Route path="unconfirmed" element={<UnconfirmedBillingPage />} />
              <Route path="confirmed" element={<ConfirmedBillingPage />} />
              <Route path="history" element={<HistoryBillingPage />} />
              <Route path="settings" element={<BillingSettingsListPage />} />
              <Route path="settings/new" element={<BillingSettingsPage />} />
              <Route path="settings/:id" element={<BillingSettingsPage />} />
            </Route>
            <Route path="partners/*" element={<Outlet />}>
              <Route index element={<PartnerListPage />} />
              <Route path=":id" element={<PartnerDetailPage />} />
              <Route
                path=":partnerId/chain-store-contracts/new"
                element={<ChainStoreContractNewPage />}
              />
              <Route
                path=":partnerId/chain-store-contracts/:id/edit"
                element={<ChainStoreContractEditPage />}
              />
              <Route
                path=":partnerId/chain-store-contracts/:id"
                element={<ChainStoreContractInspectPage />}
              />
              <Route
                path=":partnerId/refueling-contracts/new"
                element={<RefuelingContractNewPage />}
              />
              <Route
                path=":partnerId/refueling-contracts/:id/edit"
                element={<RefuelingContractEditPage />}
              />
              <Route
                path=":partnerId/refueling-contracts/:id"
                element={<RefuelingContractInspectPage />}
              />
              <Route
                path=":partnerId/parking-contracts/new"
                element={<ParkingContractNewPage />}
              />
              <Route
                path=":partnerId/parking-contracts/:id/edit"
                element={<ParkingContractEditPage />}
              />
              <Route
                path=":partnerId/parking-contracts/:id"
                element={<ParkingContractInspectPage />}
              />
            </Route>

            {/* 品牌管理 */}
            <Route path="brands" element={<BrandListPage />} />
            {/* 圖資管理 - 地圖頁 */}
            <Route path="places/*" element={<Outlet />}>
              <Route index element={<MapSearchPage />} />
              <Route path=":id" element={<PlaceInformationPage />} />
            </Route>
            <Route path="messages/*" element={<Message />}>
              <Route index element={<MessageListPage />} />
              <Route path="new" element={<MessageCreatePage />} />
              <Route path=":id/edit" element={<MessageEditPage />} />
              <Route path=":id" element={<MessageInfoPage />} />
            </Route>
            <Route path="tickets">
              <Route path="pending/:type?" element={<PendingTickets />} />
              <Route path="history/:type?" element={<HistoryTickets />} />
              <Route path="enrollments" element={<Enrollments />} />
            </Route>
            {/* 停車費率編輯頁 */}
            <Route path="parking-services/*" element={<Outlet />}>
              <Route
                path=":serviceId/parking-rates/new"
                element={<ParkingRateCreatePage />}
              />
              <Route
                path=":serviceId/parking-rates/:ruleType/:ruleIndex/edit"
                element={<ParkingRateEditPage />}
              />
            </Route>
            {/* 場站付款方式管理 */}
            <Route path="payment-methods" element={<PaymentMethodListPage />} />
            {/* 標籤管理 */}
            <Route path="tags" element={<TagListPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
